import { FcGoogle } from "react-icons/fc";
import { SiTripadvisor, SiTrustpilot, SiFacebook } from "react-icons/si";

const ICONS = { tripadvisor: SiTripadvisor, trustpilot: SiTrustpilot, facebook: SiFacebook };

export const PlatformLogo = ({ platform, color, size = "w-11 h-11", iconSize = "w-6 h-6" }) => {
  if (platform === "google") {
    return (
      <div className={`${size} rounded-xl grid place-items-center bg-white border border-slate-200 shrink-0`} data-testid={`platform-logo-${platform}`}>
        <FcGoogle className={iconSize} />
      </div>
    );
  }
  const Icon = ICONS[platform];
  return (
    <div className={`${size} rounded-xl grid place-items-center text-white shrink-0`} style={{ background: color }} data-testid={`platform-logo-${platform}`}>
      {Icon ? <Icon className={iconSize} /> : platform[0]?.toUpperCase()}
    </div>
  );
};
